// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"content-module--contentContainer--1zPtd"};